<div class="forgot-password-container">
  <div class="forgot-password-card">
    <!-- Email Step -->
    @if (step() === 'email') {
      <div class="auth-header">
        <h1 class="auth-title">Reset Password</h1>
        <p class="auth-subtitle">Enter your email address and we'll send you a verification code</p>
      </div>

      <form (ngSubmit)="onSendOtp()" class="auth-form">
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <input
            type="email"
            id="email"
            pInputText
            [(ngModel)]="email"
            name="email"
            placeholder="Enter your email"
            class="form-input"
            [class.error]="error()"
            autocomplete="email"
          />
        </div>

        @if (error()) {
          <div class="error-message">
            <i class="pi pi-exclamation-circle"></i>
            <span>{{ error() }}</span>
          </div>
        }

        <button
          type="submit"
          pButton
          label="Send Verification Code"
          icon="pi pi-send"
          [loading]="loading()"
          class="submit-button"
        ></button>

        <div class="auth-footer">
          <p>
            Remember your password?
            <a routerLink="/signin" class="auth-link">Sign in here</a>
          </p>
        </div>
      </form>
    }

    <!-- OTP Step -->
    @if (step() === 'otp') {
      <div class="otp-header">
        <button
          type="button"
          class="back-button"
          (click)="goBackToEmail()"
          title="Back to email"
        >
          <i class="pi pi-arrow-left"></i>
        </button>
        <div>
          <h1 class="auth-title">Verify Your Email</h1>
          <p class="auth-subtitle">We sent a 6-digit code to <strong>{{ email() }}</strong></p>
        </div>
      </div>

      <form (ngSubmit)="onVerifyOtp()" class="auth-form">
        <div class="form-group">
          <label for="otp" class="form-label">Verification Code</label>
          <input
            type="text"
            id="otp"
            pInputText
            [(ngModel)]="otp"
            name="otp"
            placeholder="Enter 6-digit code"
            class="form-input otp-input"
            maxlength="6"
            pattern="[0-9]*"
            inputmode="numeric"
            [class.error]="error()"
            autocomplete="one-time-code"
          />
          <p class="form-hint">Enter the 6-digit code sent to your email</p>
        </div>

        <!-- Countdown Timer -->
        @if (countdown() > 0) {
          <div class="countdown">
            <i class="pi pi-clock"></i>
            <span>Code expires in {{ formatCountdown(countdown()) }}</span>
          </div>
        } @else if (expiresAt() && countdown() === 0) {
          <div class="countdown expired">
            <i class="pi pi-exclamation-triangle"></i>
            <span>Code has expired. Please request a new one.</span>
          </div>
        }

        @if (error()) {
          <p-message severity="error" [text]="error()!" [closable]="false"></p-message>
        }

        @if (success()) {
          <p-message severity="success" [text]="success()!" [closable]="false"></p-message>
        }

        <button
          type="submit"
          pButton
          label="Verify Code"
          icon="pi pi-check"
          [loading]="loading()"
          [disabled]="!otp() || otp().length !== 6"
          class="submit-button"
        ></button>

        <!-- Resend OTP -->
        <div class="resend-section">
          <p class="resend-text">Didn't receive the code?</p>
          <button
            type="button"
            pButton
            label="Resend Code"
            icon="pi pi-refresh"
            [loading]="sendingOtp()"
            [disabled]="sendingOtp() || countdown() > 0"
            (click)="onResendOtp()"
            class="resend-button p-button-text"
          ></button>
        </div>
      </form>
    }

    <!-- Reset Password Step -->
    @if (step() === 'reset') {
      <div class="otp-header">
        <button
          type="button"
          class="back-button"
          (click)="goBackToOtp()"
          title="Back to verification"
        >
          <i class="pi pi-arrow-left"></i>
        </button>
        <div>
          <h1 class="auth-title">Create New Password</h1>
          <p class="auth-subtitle">Enter your new password below</p>
        </div>
      </div>

      <form (ngSubmit)="onResetPassword()" class="auth-form">
        <div class="form-group">
          <label for="newPassword" class="form-label">New Password</label>
          <input
            type="password"
            id="newPassword"
            pInputText
            [(ngModel)]="newPassword"
            name="newPassword"
            placeholder="Enter new password (min 6 characters)"
            class="form-input"
            [class.error]="error()"
            autocomplete="new-password"
          />
        </div>

        <div class="form-group">
          <label for="confirmPassword" class="form-label">Confirm Password</label>
          <input
            type="password"
            id="confirmPassword"
            pInputText
            [(ngModel)]="confirmPassword"
            name="confirmPassword"
            placeholder="Confirm new password"
            class="form-input"
            [class.error]="error()"
            autocomplete="new-password"
          />
        </div>

        @if (error()) {
          <div class="error-message">
            <i class="pi pi-exclamation-circle"></i>
            <span>{{ error() }}</span>
          </div>
        }

        <button
          type="submit"
          pButton
          label="Reset Password"
          icon="pi pi-lock"
          [loading]="loading()"
          class="submit-button"
        ></button>
      </form>
    }
  </div>
</div>
